<template>
  <div class="marketplace left">
    <div class="padding p-top">
      <img src="../assets/pagepunti.png" style="width: 100%" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Punti",
  components: {}
};
</script>

<style lang="less" scoped>
.padding {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;
}
.p-top {
  padding-bottom: 30px;
  padding-top: 30px;
}
.lista {
  width: 100%;
  overflow: auto;
  padding-left: 10px;
}
</style>
